<i18n>
{

	"no": {
		"title": "Rediger leverandør",
		"name": "Navn",
		"type": "Type",
		"address": "Addresse",
		"postalCode": "Postkode",
		"postalPlace": "Sted"
	},
	"en": {
		"title": "Edit vendor",
		"name": "Name",
		"type": "Type",
		"address": "Address",
		"postalCode": "Postalcode",
		"postalPlace": "Place"
	}
}

</i18n>
<template>
	<t-dialog
		:title="$t('title')"
		:isShown="isDialogShown"
		:icon="'edit'"
		iconType="bp"
		@close="$emit('close')"
		@ok="saveVendor"
		@cancel="$emit('close')"
	>
		<div v-if="vendor" class="edit-vendor-dialog">
			<div class="edit-vendor-grid">
				<t-text-input :label="$t('r10id')"  :value="vendor.r10Id" disabled/>
				<t-text-input :label="$t('name')"  :value="vendor.name" disabled/>
				<t-text-input :label="$t('type')" :value="vendor.type" disabled/>
				<t-text-input :label="$t('postalCode')" :value="vendor.postalCode" disabled/>
				<t-text-input :label="$t('postalPlace')" :value="vendor.postalPlace" disabled/>
				<t-text-input
					style="grid-column: span 3 / 4"
					:label="$t('address')"
					:value="vendor.street"
					disabled
				/>
			</div>
			<VendorEdiInformation v-if="vendor.edipartId" style="padding-top:5em" :vendor="vendor" />

		</div>
	</t-dialog>
</template>

<script>
import VendorEdiInformation from './VendorEdiInformation.vue';

export default {

	components: {
		VendorEdiInformation
	},
	
	props: {
		vendor: Object,
		isDialogShown: Boolean
	},

	methods: {
		getVendorProperty(property) {
			if (this.vendor[property])
				return this.vendor[property];
			return '';
		},
		async saveVendor() {
			await this.$emit('save', this.vendor);
		}
	}
};
</script>

<style lang="scss" scoped>


.edit-vendor-dialog{

	width: 500px;
	height: 600px;

}

.edit-vendor-grid{
	display:grid;
	grid-template-columns: repeat(3, minmax(150px, 1fr));
	column-gap: 5px;
}



</style>